import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.shared.appointments-timetable': {
         noSpecialistHasAddedWorkingTimeOnThisDay: 'Żaden specjalista nie ma dodanego czasu pracy w tym dniu.',
         noWorkSchedulesAvailable: 'Brak dostępnych harmonogramów pracy',
         save: 'Zapisz',
         showCancelled: 'Pokazuj odwołane',
         timeSlotChangeTaken: 'Nie udało się przenieść wizyty - na ten czas jest już zaplanowana inna wizyta.',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.shared.appointments-timetable');
